import type { Step } from '@lemonade-hq/chat-engine';
import type { WizardExtendedStepWithPersistence } from '@lemonade-hq/chat-wizard-client-base';
import type { I18nContextValue } from '@lemonade-hq/nuiza';
import type { UniclientStepPresentation } from '@lemonade-hq/uniclient-chat';
import { redirect } from '@lemonade-hq/uniclient-chat';

interface ErrorPageParams {
  readonly urls: {
    readonly login: string;
  };
  readonly s: I18nContextValue['s'];
}

export function errorStep401({
  s,
  urls,
}: ErrorPageParams): WizardExtendedStepWithPersistence<Step<UniclientStepPresentation, unknown>> {
  return {
    name: 'error-unauthorized',
    presentation: {
      frame: {
        title: s('chat.error.401.title'),
        action: redirect({ content: s('chat.error.401.action'), url: urls.login }),
      },
    },
  };
}
